export default {
  historiqueRecharges: [],
}
